import { useState, useEffect } from 'react';

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height
  };
}

export default function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowDimensions;
}

export const calHeightForMainSec = (height) =>{
  let header = document.querySelector('header').offsetHeight;
  let footer = document.querySelector('footer').offsetHeight;
  let pageHeading = document.querySelector('.right-sec-main h2.page-heading')?.offsetHeight || 0;
  let topTab = document.querySelector('.right-sec-main .top-tab-sec')?.offsetHeight || 0;
  let totalHeight = header+footer+10+pageHeading+topTab+30+25+10;
  let mainSec = document.querySelector('.main-form-sec');
  if(mainSec !== null && mainSec !== "null"){
    //mainSec.style.minHeight = `${height-totalHeight}px`;
  }
}